import { useEffect } from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  useEffect(() => {
    document.title = "Page Not Found";
  });

  return (
    <>
      <div className="flex h-full justify-center items-center grid grid-row-auto">
        <div className="justify-center">
          <h1>Page not found</h1>
        </div>
        <div className="justify-center">
          <Link to={"/"}>Back to Home</Link>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
